module.exports = __webpack_public_path__ + "static/media/quote-williams-learning-fr.385d105a.png";